import {useStyles} from './CustomCategoryRow.style';
import React from "react";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CustomCategoryRowProperties from "./CustomCategoryRowProperties";
import clsx from "clsx";

const CustomCategoryRow: React.FC<CustomCategoryRowProperties> = ({
                                                element,
                                                onSelect,
                                                className,
                                                selected
                                            }) => {
    const classes = useStyles();

    return (
        <div className={clsx(classes.element_row_container, className, selected && classes.active)}
             onClick={() => onSelect(element)}>
            <div className={classes.icon_info}>
                {selected && <CheckBoxIcon/>}
                {!selected && <CheckBoxOutlineBlankIcon/>}
            </div>

            <div className={classes.text_container}>
                <div>{element.code}</div>
                <div>{element.name}</div>
            </div>

        </div>
    )
}


export default CustomCategoryRow;